import React from 'react';
import styled from 'styled-components';

export const LoaderOverlay: React.FC = () => {
  return (
    <Overlay>
      {/* This can be used for global loading states */}
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 9999;
  display: none; /* Hidden by default, can be shown when needed */
  
  &.show {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;